import {
  INIT_AJAX_CALL,
  BEGIN_AJAX_CALL,
  AJAX_CALL_SUCCESS,
  AJAX_CALL_ERROR
} from "./type";

export const initAjaxCall = () => {
  return {
    type: INIT_AJAX_CALL
  };
};

export const beginAjaxCall = () => {
  return {
    type: BEGIN_AJAX_CALL
  };
};

export const ajaxCallSuccess = payload => {
  return {
    type: AJAX_CALL_SUCCESS,
    payload
  };
};

export const ajaxCallError = payload => {
  return {
    type: AJAX_CALL_ERROR,
    payload
  };
};
